import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import VerificaClienteMarketplaceModal from '../common/VerificaClienteMarketplaceModal';
import DestinatarioOrdineModal from '../common/DestinatarioOrdineModal';
import MotivoRimborsoModal from '../common/MotivoRimborsoModal';
import CodiciOmaggioBox from '../common/CodiciOmaggioBox';
import RimborsiClienteModal from '../common/RimborsiClienteModal';
import { getOrdini, deleteOrdine, exportOrdiniCSV, deleteMultipleOrdini, exportOrdiniExcel, bulkUpdateOrdiniStatus, exportTrackingMarketplace, archiveOrdiniPdfs, exportPacklinkCSV, exportPaccofacileCSV, creaSpedizioniPaccofacile, sincronizzaSpedizioniPaccofacile, scaricaEtichettePaccofacile, creaSpedizioniPacklink, sincronizzaSpedizioniPacklink, accettaOrdineMarketplace, rifiutaOrdineMarketplace, syncPendingMarketplaceOrders } from '../services/api';
import { Table, Form, Spinner, Alert, Row, Col, Dropdown, Pagination, Card, Button, ButtonGroup, Badge } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import ActionToolbar from '../common/ActionToolbar';
import MobileListLayout from '../common/MobileListLayout';
import StandardPageHeader from '../common/StandardPageHeader';
import StandardPagination from '../common/StandardPagination';
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  flexRender,
  createColumnHelper,
} from '@tanstack/react-table';
import SortableHeader from '../common/SortableHeader';
import { buildServerFilters } from '../common/serverFilterUtils';
import ColumnOrderController from '../common/ColumnOrderController';
import BulkEditOrdineModal from '../common/BulkEditOrdineModal';
import TrackingBatchModal from '../common/TrackingBatchModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faEuroSign,
  faUser,
  faCalendar,
  faMapMarkerAlt,
  faTruck,
  faCheckCircle,
  faHourglassHalf,
  faClock,
  faGripVertical,
  faHashtag,
  faTimes,
  faPlus,
  faCog,
  faFileInvoice,
  faEye,
  faEyeSlash,
  faFileExport,
  faPrint,
  faSync
} from '@fortawesome/free-solid-svg-icons';
const columnHelper = createColumnHelper();

const allColumnsMap = {
    id: "ID",
    cliente_display: "Cliente",
    corriere_denominazione: "Corriere",
    data_ordine: "Data Ordine",
    origine: "Origine",
    numero_ordine_marketplace: "Numero Ordine Marketplace",
    cliente_id: "ID Cliente",
    spese_trasporto: "Spese Trasporto",
    spese_incasso_percentuale: "Spese Incasso %",
    subtotale_imponibile: "Subtotale Imponibile",
    totale_iva: "Totale IVA",
    acconto: "Acconto",
    totale_ordine: "Totale Finale",
    costo_prodotti: "Costo Prodotti",
    costo_marketplace: "Costo Marketplace",
    margine: "Margine (€)",
    margine_percentuale: "Margine (%)",
    stato: "Stato",
    payment_method: "Metodo Pagamento",
    stato_spedizione: "Stato Spedizione",
    data_consegna: "Data Consegna",
    stato_messaggi: "Messaggi IBS",
};

const initialVisibleColumns = ['id', 'cliente_display', 'data_ordine', 'totale_ordine', 'costo_prodotti', 'margine', 'margine_percentuale', 'stato', 'stato_messaggi'];

const SELECT_FILTER_FIELDS = ['stato', 'origine', 'payment_method', 'corriere_denominazione', 'stato_spedizione'];
const DATE_RANGE_FILTER_FIELDS = ['data_ordine', 'data_consegna'];
const NUMBER_RANGE_FILTER_FIELDS = ['spese_trasporto', 'spese_incasso_percentuale', 'subtotale_imponibile', 'totale_iva', 'acconto', 'totale_ordine', 'costo_prodotti', 'costo_marketplace', 'margine', 'margine_percentuale'];
// id/cliente_id sono Integer: niente filtro testo (vedi commento nei column def piu' sotto)
const NO_FILTER_FIELDS = ['stato_messaggi', 'id', 'cliente_id'];

// Avviso mostrato prima di impostare uno stato che chiude l'ordine senza vendita: spiega cosa succede al magazzino
const MESSAGGI_STATO_CHIUSURA = {
  'Annullato': "Annullato: la merce è integra e lo stock rientra a magazzino (e viene aggiornata l'offerta su IBS).",
  'Rimborsato': "Rimborsato: l'acquirente è stato rimborsato per un pezzo difettoso, perso o respinto. Lo stock NON rientra a magazzino.",
  'Non Ritirato - Contrassegno': "Non Ritirato - Contrassegno: la merce è tornata, lo stock rientra a magazzino, le transazioni Firefly vengono stornate e al cliente viene disabilitato il pagamento in contrassegno (riabilitabile dalla sua anagrafica).",
};

// Stessi stati impostabili manualmente offerti da BulkEditOrdineModal: gli altri (Da Accettare,
// In attesa di pagamento, ecc.) sono gestiti automaticamente dal sistema, non a mano dall'utente.
const STATI_MODIFICABILI_MANUALMENTE = ["Da Evadere", "Confermato", "Parz.Concluso", "Concluso", "Annullato", "Rimborsato", "Non Ritirato - Contrassegno"];

const getStatoBadge = (stato) => {
  const statiConfig = {
    'Da Accettare': { variant: 'dark', icon: faClock },
    'Da Evadere': { variant: 'warning', icon: faClock },
    'Parz.Concluso': { variant: 'info', icon: faHourglassHalf },
    'Concluso': { variant: 'success', icon: faCheckCircle },
    'Annullato': { variant: 'danger', icon: null },
    'Rimborsato': { variant: 'dark', icon: null },
    'Non Ritirato - Contrassegno': { variant: 'danger', icon: null }
  };
  const config = statiConfig[stato] || { variant: 'secondary', icon: null };
  return (
    <Badge bg={config.variant} className="d-flex align-items-center gap-1">
      {config.icon && <FontAwesomeIcon icon={config.icon} size="xs" />}
      {stato}
    </Badge>
  );
};

// Menu di cambio stato completamente custom (niente Dropdown/Popper di react-bootstrap):
// portalato in document.body e posizionato "a mano" da getBoundingClientRect() del badge,
// per evitare sia il clipping da overflow:hidden delle celle sia i bug di posizionamento
// di Popper dentro un contenitore con scroll (il menu "scappava" col mouse).
const StatoCell = ({ ordine, changing, onChangeStato, onRequestConcludiConTracking }) => {
  const [open, setOpen] = useState(false);
  // Un ordine Rimborsato non si riapre; un Annullato puo' solo diventare Rimborsato (vedi update_ordine)
  const statiSelezionabili = (ordine.stato === 'Rimborsato' || ordine.stato === 'Non Ritirato - Contrassegno') ? []
    : ordine.stato === 'Annullato' ? ['Rimborsato']
    : STATI_MODIFICABILI_MANUALMENTE;
  const [menuPos, setMenuPos] = useState(null);
  const toggleRef = useRef(null);
  const menuRef = useRef(null);

  const openMenu = () => {
    const rect = toggleRef.current.getBoundingClientRect();
    setMenuPos({ top: rect.bottom + 4, left: rect.left });
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (
        (!toggleRef.current || !toggleRef.current.contains(e.target)) &&
        (!menuRef.current || !menuRef.current.contains(e.target))
      ) {
        setOpen(false);
      }
    };
    // Chiude il menu invece di rincorrere il badge quando la tabella o la finestra si muovono.
    const closeOnScrollOrResize = () => setOpen(false);
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', closeOnScrollOrResize, true);
    window.addEventListener('resize', closeOnScrollOrResize);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', closeOnScrollOrResize, true);
      window.removeEventListener('resize', closeOnScrollOrResize);
    };
  }, [open]);

  return (
    <>
      <span
        ref={toggleRef}
        role="button"
        style={{ cursor: statiSelezionabili.length > 0 ? 'pointer' : 'default', display: 'inline-block' }}
        title={statiSelezionabili.length === 0 ? "Un ordine rimborsato o non ritirato non può più essere modificato" : undefined}
        onClick={(e) => {
          e.stopPropagation();
          if (open) {
            setOpen(false);
          } else if (statiSelezionabili.length > 0) {
            openMenu();
          }
        }}
      >
        {getStatoBadge(ordine.stato)}
        {changing && <Spinner animation="border" size="sm" className="ms-1" />}
      </span>
      {open && menuPos && createPortal(
        <div
          ref={menuRef}
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'fixed',
            top: menuPos.top,
            left: menuPos.left,
            zIndex: 2000,
            background: '#fff',
            border: '1px solid rgba(0,0,0,.15)',
            borderRadius: '0.375rem',
            boxShadow: '0 0.5rem 1rem rgba(0,0,0,.175)',
            padding: '0.25rem 0',
            minWidth: '10rem',
          }}
        >
          {statiSelezionabili.map(stato => (
            <div
              key={stato}
              className={`px-3 py-1${stato === ordine.stato ? ' bg-light' : ''}`}
              style={{ cursor: 'pointer' }}
              title={MESSAGGI_STATO_CHIUSURA[stato]}
              onClick={() => {
                setOpen(false);
                // "Concluso" richiede quasi sempre un tracking: apre il modale dedicato
                // invece di cambiare subito stato, cosi' non serve poi entrare in modifica.
                if (stato === 'Concluso') {
                  onRequestConcludiConTracking(ordine);
                } else {
                  onChangeStato(ordine, stato);
                }
              }}
            >
              {getStatoBadge(stato)}
            </div>
          ))}
        </div>,
        document.body
      )}
    </>
  );
};

const visibilityKey = 'table-visibility-ordini';
const orderKeyBase = 'table-column-order-ordini';
const activeViewKey = 'ordini-active-view';

const columnPresetsConfig = [
  { key: 'essenziale', label: '📋 Vista essenziale' },
  { key: 'finanziaria', label: '💰 Vista finanziaria' },
  { key: 'logistica', label: '🚚 Vista logistica' },
  { key: 'completa', label: '📊 Vista completa' }
];

const columnPresets = {
  essenziale: ['id', 'cliente_display', 'data_ordine', 'origine', 'acconto', 'totale_ordine', 'stato', 'payment_method'],
  finanziaria: ['id', 'cliente_display', 'totale_ordine', 'costo_prodotti', 'margine', 'margine_percentuale', 'acconto'],
  logistica: ['id', 'cliente_display', 'corriere_denominazione', 'numero_ordine_marketplace', 'stato', 'origine'],
  completa: Object.keys(allColumnsMap)
};

// Chiavi di storage per vista: 'custom' usa le chiavi storiche (retrocompatibilita), le viste preimpostate hanno chiavi dedicate
const getVisibilityKey = (view) => view === 'custom' ? visibilityKey : `${visibilityKey}-${view}`;
const getOrderKey = (view) => view === 'custom' ? orderKeyBase : `${orderKeyBase}-${view}`;

function OrdiniList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isMobile = useMediaQuery({ maxWidth: 991 });
  const [ordini, setOrdini] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOrdineIds, setSelectedOrdineIds] = useState([]);
  const [rowSelection, setRowSelection] = useState({}); // Aggiunto per tanstack-table
  const [exporting, setExporting] = useState(false);
  const [exportingExcel, setExportingExcel] = useState(false);
  const [exportingTracking, setExportingTracking] = useState(false);
  const [exportingPacklink, setExportingPacklink] = useState(false);
  const [exportingPaccofacile, setExportingPaccofacile] = useState(false);
  const [creandoSpedizioni, setCreandoSpedizioni] = useState(false);
  const [sincronizzandoPaccofacile, setSincronizzandoPaccofacile] = useState(false);
  const [creandoPacklink, setCreandoPacklink] = useState(false);
  const [sincronizzandoPacklink, setSincronizzandoPacklink] = useState(false);
  const [scaricandoEtichette, setScaricandoEtichette] = useState(false);
  const [processingMarketplaceIds, setProcessingMarketplaceIds] = useState(new Set());
  const [ordineVerificaCliente, setOrdineVerificaCliente] = useState(null);
  const [ordineDestinatario, setOrdineDestinatario] = useState(null); // modal "destinatario diverso dall'acquirente"
  const [ordineRimborsi, setOrdineRimborsi] = useState(null); // modal "rimborsi precedenti del cliente"
  const [ordineMotivoRimborso, setOrdineMotivoRimborso] = useState(null); // modal motivo al cambio stato in Rimborsato
  const [changingStatoIds, setChangingStatoIds] = useState(new Set());
  const idClickTimeoutRef = useRef(null);
  const [syncingPendingOrders, setSyncingPendingOrders] = useState(false);
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [trackingModalOrdini, setTrackingModalOrdini] = useState([]);
  const deleteApiMap = { ordini: deleteOrdine };
  const deleteMultipleApiMap = { ordini: deleteMultipleOrdini };
  const [distinctValues, setDistinctValues] = useState({
    stato: [],
    origine: [],
    payment_method: [],
    corriere_denominazione: [],
    stato_spedizione: [],
  });
  
  // Mantiene tutte le opzioni originali per i filtri multiselect
  const [allDistinctValues, setAllDistinctValues] = useState({
    stato: [],
    origine: [],
    payment_method: [],
    corriere_denominazione: [],
    stato_spedizione: [],
  });

  const [activeView, setActiveView] = useState(() => {
    return localStorage.getItem(activeViewKey) || 'custom';
  });

  const [columnVisibility, setColumnVisibility] = useState(() => {
    const saved = localStorage.getItem(getVisibilityKey(activeView));
    if (saved) {
      return JSON.parse(saved);
    }
    if (columnPresets[activeView]) {
      return Object.keys(allColumnsMap).reduce((acc, key) => {
        acc[key] = columnPresets[activeView].includes(key);
        return acc;
      }, {});
    }
    return Object.keys(allColumnsMap).reduce((acc, key) => {
      acc[key] = initialVisibleColumns.includes(key);
      return acc;
    }, {});
  });
  const [sorting, setSorting] = useState(() => {
    const saved = sessionStorage.getItem('list-sorting-ordini');
    return saved ? JSON.parse(saved) : [];
  });

  const [columnFilters, setColumnFilters] = useState(() => {
    const saved = sessionStorage.getItem('list-filters-ordini');
    return saved ? JSON.parse(saved) : [];
  });
  
  const [columnOrder, setColumnOrder] = useState(() => {
    const savedOrder = localStorage.getItem(getOrderKey(activeView));
    const defaultOrder = ['select', 'marketplace_action', ...Object.keys(allColumnsMap)]; // Rimosso 'actions' qui, verrà aggiunto dopo se presente in allColumnsMap
    if (savedOrder) {
        let parsedOrder = JSON.parse(savedOrder);
        // Assicurati che 'select' e 'marketplace_action' siano sempre presenti in testa e non duplicate
        parsedOrder = parsedOrder.filter(c => c !== 'select' && c !== 'marketplace_action');
        return ['select', 'marketplace_action', ...parsedOrder];
    }
    return defaultOrder;
  });
  const [columnSizing, setColumnSizing] = useState(() => {
    const saved = localStorage.getItem('table-column-sizing-ordini');
    return saved ? JSON.parse(saved) : {};
  });
  const [quickFilterStatus, setQuickFilterStatus] = useState(null); // 'Da Evadere', 'Parz.Concluso', 'Concluso' oppure {in: [...]}

  // Viste dedicate raggiunte dalla sidebar (?quick=...): filtro fisso, niente toggle in pagina
  const quickParam = searchParams.get('quick');
  const isFilteredView = ['in_lavorazione', 'da_accettare', 'concluso', 'annullati', 'rimborsi', 'destinatario', 'senza_rapporto'].includes(quickParam);

  useEffect(() => {
    if (quickParam === 'in_lavorazione') {
      setQuickFilterStatus({ in: ['Da Evadere', 'Confermato', 'Pagamento verificato', 'Parz.Concluso'] });
    } else if (quickParam === 'da_accettare') {
      setQuickFilterStatus('Da Accettare');
    } else if (quickParam === 'concluso') {
      setQuickFilterStatus('Concluso');
    } else if (quickParam === 'annullati') {
      setQuickFilterStatus({ in: ['Annullato', 'Rimborsato', 'Non Ritirato - Contrassegno'] });
    } else {
      setQuickFilterStatus(null);
    }
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickParam]);

  const [excludeConcluded, setExcludeConcluded] = useState(() => {
    const saved = localStorage.getItem('ordini-exclude-concluded');
    return saved ? JSON.parse(saved) : true;
  });
  const [isCondensed, setIsCondensed] = useState(() => {
    const saved = localStorage.getItem('table-condensed-ordini');
    return saved ? JSON.parse(saved) : false;
  });
  const [quickSearch, setQuickSearch] = useState(() => {
    const saved = sessionStorage.getItem('list-filters-ordini');
    if (saved) {
      const filters = JSON.parse(saved);
      const gs = filters.find(f => f.id === '_global_search');
      return gs ? gs.value : '';
    }
    return '';
  });

  useEffect(() => {
    sessionStorage.setItem('list-sorting-ordini', JSON.stringify(sorting));
  }, [sorting]);

  useEffect(() => {
    sessionStorage.setItem('list-filters-ordini', JSON.stringify(columnFilters));
  }, [columnFilters]);

  useEffect(() => {
    localStorage.setItem(getOrderKey(activeView), JSON.stringify(columnOrder));
  }, [columnOrder, activeView]);

  useEffect(() => {
    localStorage.setItem(activeViewKey, activeView);
  }, [activeView]);

  useEffect(() => {
    localStorage.setItem('table-column-sizing-ordini', JSON.stringify(columnSizing));
  }, [columnSizing]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setColumnFilters(prev => {
        const without = prev.filter(f => f.id !== '_global_search');
        if (quickSearch) return [...without, { id: '_global_search', value: quickSearch }];
        return without;
      });
      setCurrentPage(1);
    }, 400);
    return () => clearTimeout(timer);
  }, [quickSearch]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalOrdini, setTotalOrdini] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalMargin, setTotalMargin] = useState(0); // New state for total margin
  const [totalAcconti, setTotalAcconti] = useState(0);
  const [reportTitle, setReportTitle] = useState('Tutti gli Ordini');

// Numero dell'ultima richiesta: una risposta arrivata dopo una piu' recente (ricerca digitata, filtri cambiati
  // in fretta) non deve sovrascrivere tabella e totali del filtro attuale
  const ultimaRichiesta = useRef(0);

const fetchOrdiniData = useCallback(async () => {
    const richiesta = ++ultimaRichiesta.current;
    setLoading(true);
    setError(null);
    try {
      const currentFilters = buildServerFilters(columnFilters);

      // Il filtro "Stato" scelto esplicitamente (dal popover colonna o dalle viste
      // rapide in header) vince sempre. "Solo attivi" e' solo il default quando
      // nessuno dei due e' impostato: prima veniva applicato sempre, anche sopra
      // uno stato scelto a mano nel popover, che quindi non aveva mai effetto reale.
      if (quickParam === 'rimborsi') {
        // Vista dell'avviso in header: ordini da evadere di clienti con rimborsi precedenti, senza decisione
        currentFilters._rimborsi_da_valutare = true;
      } else if (quickParam === 'senza_rapporto') {
        // Ordini conclusi senza rapporto di incasso: non registrati su Firefly
        currentFilters._senza_rapporto = true;
      } else if (quickParam === 'destinatario') {
        // Vista dell'avviso in header: ordini spediti a un nome diverso dall'acquirente, scelta in attesa
        currentFilters._destinatario_da_verificare = true;
      } else if (!('stato' in currentFilters)) {
        if (quickFilterStatus) {
          currentFilters.stato = quickFilterStatus;
        } else if (excludeConcluded) {
          currentFilters.stato = { in: ['Da Accettare', 'Da Evadere', 'Parz.Concluso'] };
        }
      }

      const filters = JSON.stringify(currentFilters);
      let sortParams = sorting.map(sort => `${sort.id}:${sort.desc ? 'desc' : 'asc'}`);

      // Se non ci sono ordinamenti impostati dall'utente, aggiungi l'ordinamento di default per ID decrescente
      if (sortParams.length === 0) {
        sortParams = ['id:desc'];
      }

      const response = await getOrdini(
        (currentPage - 1) * itemsPerPage,
        itemsPerPage,
        sortParams,
        filters
      );
      if (richiesta !== ultimaRichiesta.current) return;
      setOrdini(response.data.ordini);
      setTotalOrdini(response.data.total);
      setTotalAmount(response.data.total_amount);
      setTotalMargin(response.data.total_margin);
      setTotalAcconti(response.data.total_acconti);
      if (response.data.facets) {
        setDistinctValues(response.data.facets);
        
        // Per i multiselect, mantieni tutte le opzioni originali
        setAllDistinctValues(prev => {
          const multiselectColumns = ['stato', 'origine', 'payment_method', 'corriere_denominazione', 'stato_spedizione'];
          const updated = { ...prev };
          
          multiselectColumns.forEach(col => {
            if (response.data.facets[col]) {
              // Combina opzioni esistenti con nuove (union)
              const existing = prev[col] || [];
              const newValues = response.data.facets[col] || [];
              updated[col] = [...new Set([...existing, ...newValues])];
            }
          });
          
          return updated;
        });
      }
    } catch (err) {
      if (richiesta !== ultimaRichiesta.current) return;
      setError('Errore nel caricamento degli ordini.');
      console.error(err);
    } finally {
      if (richiesta === ultimaRichiesta.current) setLoading(false);
    }
  }, [currentPage, itemsPerPage, sorting, columnFilters, quickFilterStatus, excludeConcluded, quickParam]);

  useEffect(() => {
    fetchOrdiniData();
  }, [fetchOrdiniData]);
  
  // Aggiorna reportTitle in base ai filtri attivi
  useEffect(() => {
    if (columnFilters.length === 0) {
      setReportTitle('Tutti gli Ordini');
    } else if (columnFilters.length === 1 && columnFilters[0].id === 'stato') {
      const filterValue = columnFilters[0].value;
      if (typeof filterValue === 'string') {
        setReportTitle(filterValue);
      } else {
        setReportTitle('Ordini Filtrati');
      }
    } else {
      setReportTitle('Ordini Filtrati');
    }
  }, [columnFilters]);

  // Helper functions for icons and badges
  // getStatoBadge e' definita a livello di modulo (serve anche a StatoCell fuori da questo componente)

  const getMessaggiBadge = (stato) => {
    const statiConfig = {
      'Risposto': { variant: 'success', icon: faCheckCircle },
      'Da Rispondere': { variant: 'danger', icon: faClock },
      'Non Presente': { variant: 'secondary', icon: null },
    };
    const config = statiConfig[stato] || { variant: 'secondary', icon: null };
    return (
      <Badge bg={config.variant} className="d-flex align-items-center gap-1">
        {config.icon && <FontAwesomeIcon icon={config.icon} size="xs" />}
        {stato}
      </Badge>
    );
  };

  const getOrigineIcon = (origine) => {
    const originiIcons = {
      'SITO WEB': '🌐',
      'NEGOZIO': '🏪',
      'IBS': '📚',
      'FELTRINELLI': '📖',
      'AMAZON': '📦'
    };
    return originiIcons[origine] || '📋';
  };

  const formatCurrency = (value) => {
    if (value == null) return 'N/A';
    const num = parseFloat(value);
    const formatted = num.toFixed(2);
    const colorClass = num < 0 ? 'text-danger' : num > 0 ? 'text-success' : 'text-muted';
    return <span className={colorClass}>€ {formatted}</span>;
  };

  const getColumnValue = (ordine, columnName) => {
    switch (columnName) {
      case 'cliente_display':
        if (!ordine.cliente) return 'N/A';
        const { nome, cognome, denominazione_sociale } = ordine.cliente;
        const namePart = [nome, cognome].filter(Boolean).join(' ');
        if (denominazione_sociale) {
          return namePart ? `${namePart} (${denominazione_sociale})` : denominazione_sociale;
        }
        return namePart || 'Cliente non specificato';
      case 'corriere_denominazione':
        return ordine.corriere ? ordine.corriere.denominazione : 'N/A';
      case 'data_ordine':
        return ordine.data_ordine ? new Date(ordine.data_ordine).toLocaleDateString() : 'N/A';
      case 'stato':
        return (
          <StatoCell
            ordine={ordine}
            changing={changingStatoIds.has(ordine.id)}
            onChangeStato={handleChangeStato}
            onRequestConcludiConTracking={(o) => handleOpenTrackingModal([o])}
          />
        );
      case 'origine':
        return (
          <span>
            {getOrigineIcon(ordine.origine)} {ordine.origine || 'N/A'}
          </span>
        );
      case 'subtotale_imponibile':
      case 'totale_iva':
      case 'acconto':
      case 'totale_ordine':
      case 'costo_prodotti':
      case 'costo_marketplace':
      case 'margine':
      case 'spese_trasporto':
        return ordine[columnName] != null ? formatCurrency(ordine[columnName]) : 'N/A';
      case 'margine_percentuale':
        if (ordine.margine_percentuale == null) return 'N/A';
        const percentValue = ordine.margine_percentuale;
        const colorClass = percentValue < 0 ? 'text-danger' : percentValue > 0 ? 'text-success' : 'text-muted';
        return <span className={colorClass}>{percentValue.toFixed(2)} %</span>;
      case 'payment_method':
        if (['IBS', 'FELTRINELLI'].includes(ordine.origine)) return 'TRANSITO IBS';
        // Ordini del sito: metodo scelto dal cliente; negozio, riversamenti e altro: rapporto su cui e' stato incassato
        if (ordine[columnName]) return ordine[columnName].toUpperCase();
        return ordine.banca && ordine.banca.denominazione ? ordine.banca.denominazione.toUpperCase() : 'N/A';
      case 'numero_ordine_marketplace':
        return ordine[columnName] || 'N/A';
      case 'stato_spedizione':
        if (!ordine.stato_spedizione) return 'N/A';
        return (
          <Badge bg={ordine.stato_spedizione === 'Consegnato' ? 'success' : 'warning'}>
            {ordine.stato_spedizione}
          </Badge>
        );
      case 'data_consegna':
        return ordine.data_consegna ? new Date(ordine.data_consegna).toLocaleDateString() : 'N/A';
      case 'stato_messaggi':
        return getMessaggiBadge(ordine.stato_messaggi);
      default:
        return ordine[columnName];
    }
  };

  const columns = useMemo(
    () => [
      columnHelper.display({
        id: 'select',
        header: ({ table }) => (
          <Form.Check
            type="checkbox"
            onChange={table.getToggleAllRowsSelectedHandler()}
            checked={table.getIsAllRowsSelected()}
            disabled={ordini.length === 0}
          />
        ),
        cell: ({ row }) => (
          <Form.Check
            type="checkbox"
            checked={row.getIsSelected()}
            onChange={row.getToggleSelectedHandler()}
            onClick={(e) => e.stopPropagation()}
          />
        ),
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableResizing: false,
        enableSorting: false,
        enableColumnFilter: false,
      }),
      columnHelper.display({
        id: 'marketplace_action',
        header: () => 'Azioni',
        cell: ({ row }) => renderMarketplaceActionButton(row.original),
        minSize: 160,
        enableResizing: false,
        enableSorting: false,
        enableColumnFilter: false,
      }),
      ...Object.entries(allColumnsMap).map(([key, value]) => {
        const isSelect = SELECT_FILTER_FIELDS.includes(key);
        let filterVariant = 'text';
        if (isSelect) filterVariant = 'select';
        else if (DATE_RANGE_FILTER_FIELDS.includes(key)) filterVariant = 'date-range';
        else if (NUMBER_RANGE_FILTER_FIELDS.includes(key)) filterVariant = 'number-range';

        return columnHelper.accessor(key, {
          header: () => value,
          cell: info => getColumnValue(info.row.original, key),
          // stato_messaggi e' calcolato in Python (non e' una colonna DB): niente filtro/sort lato server.
          // id/cliente_id sono colonne Integer: un filtro 'text' (ilike) ci spaccherebbe la query in
          // Postgres ("operator does not exist: integer ~~ unknown") — la ricerca per ID la copre gia' _global_search.
          enableColumnFilter: !NO_FILTER_FIELDS.includes(key),
          enableSorting: key !== 'stato_messaggi',
          meta: {
            filterVariant,
            filterOptions: isSelect ? allDistinctValues[key] : distinctValues[key],
          },
        });
      }),
    ],
    [ordini, distinctValues, allDistinctValues, processingMarketplaceIds, changingStatoIds]
  );

  const onColumnVisibilityChange = (updater) => {
    const newState = typeof updater === 'function' ? updater(columnVisibility) : updater;
    setColumnVisibility(newState);
    localStorage.setItem(getVisibilityKey(activeView), JSON.stringify(newState));
  };

  const table = useReactTable({
    data: ordini,
    columns,
    state: {
      columnVisibility,
      sorting,
      columnFilters,
      columnOrder,
      columnSizing,
      rowSelection,
    },
    onColumnVisibilityChange: onColumnVisibilityChange,
    // Selezione legata all'ID dell'ordine, non alla posizione: cambiando pagina/filtro/ricerca le azioni
    // massive restano sugli ordini scelti (quelli non piu' visibili non vengono toccati)
    getRowId: (row) => String(row.id),
    onRowSelectionChange: setRowSelection,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    onColumnOrderChange: setColumnOrder,
    onColumnSizingChange: setColumnSizing,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    enableRowSelection: true, // Abilita la selezione delle righe
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
    enableColumnReordering: true,
    manualFiltering: true,
  });

  const handleAutoResize = (column) => {
    // Define optimal widths for each column type
    const columnOptimalWidths = {
      'id': 80,
      'cliente_display': 200,
      'data_ordine': 110,
      'origine': 120,
      'numero_ordine_marketplace': 180,
      'acconto': 100,
      'totale_ordine': 110,
      'subtotale_imponibile': 130,
      'totale_iva': 100,
      'costo_prodotti': 120,
      'costo_marketplace': 140,
      'margine': 110,
      'margine_percentuale': 120,
      'stato': 140,
      'payment_method': 150,
      'corriere_denominazione': 150,
      'spese_trasporto': 130,
      'cliente_id': 90,
      'stato_spedizione': 140,
      'data_consegna': 120
    };
    
    const optimalWidth = columnOptimalWidths[column.id] || 120;

    table.setColumnSizing(prev => ({
      ...prev,
      [column.id]: optimalWidth,
    }));
  };

  const { rows } = table.getSelectedRowModel()
  useEffect(() => {
    setSelectedOrdineIds(rows.map(row => row.original.id))
  }, [rows])

  const handleRowClick = (row) => {
    row.toggleSelected();
  };

  useEffect(() => {
    return () => {
      if (idClickTimeoutRef.current) clearTimeout(idClickTimeoutRef.current);
    };
  }, []);

  // Click singolo sulla colonna ID -> visualizza ordine, doppio click -> modifica.
  // Non c'e' un evento "doppio click" nativo affidabile qui perche' il click singolo
  // dovrebbe attendere per capire se arriva un secondo click prima di navigare.
  const handleIdCellClick = (e, ordineId) => {
    e.stopPropagation();
    if (idClickTimeoutRef.current) {
      clearTimeout(idClickTimeoutRef.current);
      idClickTimeoutRef.current = null;
      navigate(`/ordini/edit/${ordineId}`);
    } else {
      idClickTimeoutRef.current = setTimeout(() => {
        idClickTimeoutRef.current = null;
        navigate(`/ordini/${ordineId}`);
      }, 250);
    }
  };

  const handleChangeStato = async (ordine, nuovoStato, motivoRimborso = null) => {
    if (nuovoStato === ordine.stato) return;
    // Rimborsato: il modale chiede il motivo (e mostra l'avviso sullo stock) e poi richiama questa funzione
    if (nuovoStato === 'Rimborsato' && !motivoRimborso) {
      setOrdineMotivoRimborso(ordine);
      return;
    }
    if (nuovoStato !== 'Rimborsato' && MESSAGGI_STATO_CHIUSURA[nuovoStato] && !window.confirm(`Ordine #${ordine.id}

${MESSAGGI_STATO_CHIUSURA[nuovoStato]}

Confermi?`)) return;
    setChangingStatoIds(prev => new Set(prev).add(ordine.id));
    setError(null);
    try {
      await bulkUpdateOrdiniStatus([ordine.id], nuovoStato, motivoRimborso);
      await fetchOrdiniData();
    } catch (err) {
      setError(err.response?.data?.detail || `Errore durante il cambio di stato dell'ordine #${ordine.id}.`);
    } finally {
      setChangingStatoIds(prev => {
        const next = new Set(prev);
        next.delete(ordine.id);
        return next;
      });
    }
  };

  const handleOpenTrackingModal = (ordiniDaConcludere) => {
    setTrackingModalOrdini(ordiniDaConcludere);
  };

  const handleExportSelected = async () => {
    setExporting(true);
    setError(null);
    try {
      const response = await exportOrdiniCSV(selectedOrdineIds);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ordini_selezionati.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      table.toggleAllRowsSelected(false);
    } catch (err) {
      setError('Errore durante l\'esportazione degli ordini selezionati.');
    } finally {
      setExporting(false);
    }
  };

  const handleExportAllExcel = async () => {
    setExportingExcel(true);
    setError(null);
    try {
      const response = await exportOrdiniExcel();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ordini.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError('Errore durante l\'esportazione di tutti gli ordini in Excel.');
    } finally {
      setExportingExcel(false);
    }
  };

  const handleExportTracking = async () => {
    if (selectedOrdineIds.length === 0) {
      alert("Nessun ordine selezionato per l'esportazione del tracking.");
      return;
    }
    setExportingTracking(true);
    setError(null);
    try {
      const response = await exportTrackingMarketplace(selectedOrdineIds);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ordini_tracking.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      table.toggleAllRowsSelected(false);
    } catch (err) {
      setError('Errore durante l\'esportazione del tracking degli ordini selezionati.');
      console.error(err);
    } finally {
      setExportingTracking(false);
    }
  };

  const handleExportPacklink = async () => {
    if (selectedOrdineIds.length === 0) {
      alert("Nessun ordine selezionato per l'esportazione Packlink CSV.");
      return;
    }
    setExportingPacklink(true);
    setError(null);
    try {
      const response = await exportPacklinkCSV(selectedOrdineIds);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'packlink_export.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      table.toggleAllRowsSelected(false);
    } catch (err) {
      setError('Errore durante l\'esportazione Packlink CSV degli ordini selezionati.');
      console.error(err);
    } finally {
      setExportingPacklink(false);
    }
  };

  const handleExportPaccofacile = async () => {
    if (selectedOrdineIds.length === 0) {
      alert("Nessun ordine selezionato per l'esportazione PaccoFacile CSV.");
      return;
    }
    setExportingPaccofacile(true);
    setError(null);
    try {
      const response = await exportPaccofacileCSV(selectedOrdineIds);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'paccofacile_export.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      table.toggleAllRowsSelected(false);
    } catch (err) {
      // La risposta e' un blob: se il backend ha bloccato l'export (es. destinatario da verificare) il motivo e' nel JSON
      let dettaglio = null;
      try { dettaglio = JSON.parse(await err.response?.data?.text())?.detail; } catch (e) { /* risposta non JSON */ }
      setError(dettaglio || 'Errore durante l\'esportazione PaccoFacile CSV degli ordini selezionati.');
      console.error(err);
    } finally {
      setExportingPaccofacile(false);
    }
  };

  const handleCreaSpedizioniPaccofacile = async () => {
    if (selectedOrdineIds.length === 0) {
      alert("Nessun ordine selezionato.");
      return;
    }
    if (!window.confirm(
      `Creare su PaccoFacile ${selectedOrdineIds.length} spedizione/i?\n\n` +
      `Le spedizioni restano da acquistare: le trovi in "Spedizioni configurate" sul sito PaccoFacile, ` +
      `dove puoi cambiare il servizio e pagarle.`
    )) return;

    setCreandoSpedizioni(true);
    setError(null);
    try {
      const { data } = await creaSpedizioniPaccofacile(selectedOrdineIds);
      const righe = [`Spedizioni create: ${data.create.length}`];
      if (data.gia_presenti.length > 0) righe.push(`Già presenti (saltate): ${data.gia_presenti.length}`);
      if (data.errori.length > 0) {
        righe.push(`\nNon create (${data.errori.length}):`);
        data.errori.forEach(e => righe.push(`  Ordine ${e.ordine_id}: ${e.errore}`));
      }
      alert(righe.join('\n'));
      table.toggleAllRowsSelected(false);
      fetchOrdiniData();
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante la creazione delle spedizioni PaccoFacile.');
      console.error(err);
    } finally {
      setCreandoSpedizioni(false);
    }
  };

  const handleCreaSpedizioniPacklink = async () => {
    if (selectedOrdineIds.length === 0) {
      alert("Nessun ordine selezionato.");
      return;
    }
    if (!window.confirm(
      `Creare su Packlink PRO ${selectedOrdineIds.length} bozza/e di spedizione?\n\n` +
      `Servizio e pagamento si scelgono su Packlink PRO, tra le spedizioni da completare. ` +
      `Dopo il pagamento usa "Aggiorna tracking Packlink".`
    )) return;

    setCreandoPacklink(true);
    setError(null);
    try {
      const { data } = await creaSpedizioniPacklink(selectedOrdineIds);
      const righe = [`Bozze create: ${data.create.length}`];
      if (data.gia_presenti.length > 0) righe.push(`Già con una spedizione (saltate): ${data.gia_presenti.length}`);
      if (data.errori.length > 0) {
        righe.push(`\nNon create (${data.errori.length}):`);
        data.errori.forEach(e => righe.push(`  Ordine ${e.ordine_id}: ${e.errore}`));
      }
      alert(righe.join('\n'));
      table.toggleAllRowsSelected(false);
      fetchOrdiniData();
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante la creazione delle bozze Packlink.');
      console.error(err);
    } finally {
      setCreandoPacklink(false);
    }
  };

  const handleSincronizzaPacklink = async () => {
    setSincronizzandoPacklink(true);
    setError(null);
    try {
      const { data } = await sincronizzaSpedizioniPacklink();
      const righe = [`Tracking aggiornati: ${data.aggiornati.length}`];
      if (data.in_attesa_di_acquisto.length > 0) {
        righe.push(`Ancora da pagare su Packlink: ${data.in_attesa_di_acquisto.length}`);
      }
      if (data.errori.length > 0) righe.push(`Errori: ${data.errori.length}`);
      alert(righe.join('\n'));
      if (data.aggiornati.length > 0) fetchOrdiniData();
    } catch (err) {
      setError('Errore durante la sincronizzazione delle spedizioni Packlink.');
      console.error(err);
    } finally {
      setSincronizzandoPacklink(false);
    }
  };

  const handleScaricaEtichette = async () => {
    if (selectedOrdineIds.length === 0) {
      alert("Nessun ordine selezionato.");
      return;
    }
    setScaricandoEtichette(true);
    setError(null);
    try {
      const response = await scaricaEtichettePaccofacile(selectedOrdineIds);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'etichette_paccofacile.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      const mancanti = parseInt(response.headers['x-etichette-mancanti'] || '0', 10);
      if (mancanti > 0) {
        alert(`${mancanti} etichetta/e non erano ancora pronte e non sono nel PDF.\nRiprova tra qualche minuto: vengono generate dal corriere dopo l'acquisto.`);
      }
    } catch (err) {
      // La risposta d'errore arriva come blob: va letta per mostrare il messaggio del backend.
      let messaggio = 'Errore durante il download delle etichette.';
      if (err.response?.data instanceof Blob) {
        try {
          messaggio = JSON.parse(await err.response.data.text()).detail || messaggio;
        } catch { /* resta il messaggio generico */ }
      }
      setError(messaggio);
      console.error(err);
    } finally {
      setScaricandoEtichette(false);
    }
  };

  const handleSincronizzaPaccofacile = async () => {
    setSincronizzandoPaccofacile(true);
    setError(null);
    try {
      const { data } = await sincronizzaSpedizioniPaccofacile();
      const righe = [`Tracking aggiornati: ${data.aggiornati.length}`];
      if (data.in_attesa_di_acquisto.length > 0) {
        righe.push(`In attesa di acquisto o di lettera di vettura: ${data.in_attesa_di_acquisto.length}`);
      }
      if (data.errori.length > 0) righe.push(`Errori: ${data.errori.length}`);
      alert(righe.join('\n'));
      if (data.aggiornati.length > 0) fetchOrdiniData();
    } catch (err) {
      setError('Errore durante la sincronizzazione delle spedizioni PaccoFacile.');
      console.error(err);
    } finally {
      setSincronizzandoPaccofacile(false);
    }
  };

  const handleAcceptMarketplaceOrder = async (ordine) => {
    setProcessingMarketplaceIds(prev => new Set(prev).add(ordine.id));
    setError(null);
    try {
      await accettaOrdineMarketplace(ordine.id);
      await fetchOrdiniData();
    } catch (err) {
      setError(err.response?.data?.detail || `Errore durante l'accettazione dell'ordine #${ordine.id}.`);
    } finally {
      setProcessingMarketplaceIds(prev => {
        const next = new Set(prev);
        next.delete(ordine.id);
        return next;
      });
    }
  };

  const handleRefuseMarketplaceOrder = async (ordine) => {
    if (!window.confirm(`Rifiutare l'ordine #${ordine.id}? L'operazione non è reversibile.`)) return;
    setProcessingMarketplaceIds(prev => new Set(prev).add(ordine.id));
    setError(null);
    try {
      const response = await rifiutaOrdineMarketplace(ordine.id);
      if (response.data?.warning) {
        alert(response.data.warning);
      }
      await fetchOrdiniData();
    } catch (err) {
      setError(err.response?.data?.detail || `Errore durante il rifiuto dell'ordine #${ordine.id}.`);
    } finally {
      setProcessingMarketplaceIds(prev => {
        const next = new Set(prev);
        next.delete(ordine.id);
        return next;
      });
    }
  };

  const handleSyncPendingMarketplaceOrders = async () => {
    setSyncingPendingOrders(true);
    setError(null);
    try {
      const response = await syncPendingMarketplaceOrders();
      const { trovati, importati, errori } = response.data;
      let message = importati.length > 0
        ? `Importati ${importati.length} nuovi ordini da accettare (su ${trovati} trovati su Mirakl).`
        : `Nessun nuovo ordine da importare (${trovati} ordini trovati su Mirakl, già tutti presenti).`;
      if (errori.length > 0) {
        message += `\n\nAttenzione: ${errori.length} ordini non importati per errore:\n` + errori.map(e => `- ${e.order_id}: ${e.error}`).join('\n');
      }
      alert(message);
      await fetchOrdiniData();
    } catch (err) {
      setError(err.response?.data?.detail || "Errore durante la verifica dei nuovi ordini marketplace.");
    } finally {
      setSyncingPendingOrders(false);
    }
  };

  const renderMarketplaceActionButton = (ordine) => {
    const verificaCliente = ['IBS', 'FELTRINELLI'].includes(ordine.origine) && ordine.cliente_da_verificare ? (
      <Button
        size="sm"
        variant="warning"
        title="Il cliente potrebbe esistere già in anagrafica: scegli a quale collegare l'ordine"
        onClick={(e) => { e.stopPropagation(); setOrdineVerificaCliente(ordine); }}
      >
        Verifica cliente
      </Button>
    ) : null;
    // Avviso per qualsiasi motivo di rimborso; rosso se tra i motivi c'e' un reso o un'immagine diversa dalle attese
    const rimborsi = ordine.rimborsi_da_valutare ? (
      <Button
        size="sm"
        variant={ordine.rimborsi_precedenti_gravi ? 'danger' : 'secondary'}
        title="Il cliente ha già avuto ordini rimborsati: guarda i motivi e decidi se evadere o rifiutare l'ordine"
        onClick={(e) => { e.stopPropagation(); setOrdineRimborsi(ordine); }}
      >
        Rimborsi precedenti ({ordine.rimborsi_precedenti})
      </Button>
    ) : null;
    const destinatario = ordine.destinatario_da_verificare ? (
      <Button
        size="sm"
        variant="warning"
        title="Il nome di spedizione è diverso da quello dell'acquirente: scegli quale usare in etichetta"
        onClick={(e) => { e.stopPropagation(); setOrdineDestinatario(ordine); }}
      >
        Verifica destinatario
      </Button>
    ) : null;
    const azione = renderAzioneMarketplace(ordine);
    if (!verificaCliente && !destinatario && !rimborsi && !azione) return null;
    return <div className="d-flex flex-column gap-1 align-items-start">{verificaCliente}{destinatario}{rimborsi}{azione}</div>;
  };

  const renderAzioneMarketplace = (ordine) => {
    if (ordine.stato !== 'Da Accettare' || !['IBS', 'FELTRINELLI'].includes(ordine.origine)) return null;
    const isProcessing = processingMarketplaceIds.has(ordine.id);
    if (ordine.marketplace_stock_ok === false) {
      return (
        <Button
          size="sm"
          variant="danger"
          disabled={isProcessing}
          onClick={(e) => { e.stopPropagation(); handleRefuseMarketplaceOrder(ordine); }}
        >
          {isProcessing ? <Spinner as="span" animation="border" size="sm" /> : 'Rifiuta (stock 0)'}
        </Button>
      );
    }
    return (
      <Button
        size="sm"
        variant="success"
        disabled={isProcessing}
        onClick={(e) => { e.stopPropagation(); handleAcceptMarketplaceOrder(ordine); }}
      >
        {isProcessing ? <Spinner as="span" animation="border" size="sm" /> : 'Accetta e importa'}
      </Button>
    );
  };

  const handleShowPrintModal = async () => {
    if (selectedOrdineIds.length > 0) {
      navigate(`/ordini/lista-evasione/print?ordine_ids=${selectedOrdineIds.join(',')}`);
    } else {
      navigate('/ordini/lista-evasione/print');
    }
  };

  // La funzione handlePrint non è più necessaria in questo componente, in quanto la stampa è gestita dal componente ListaEvasionePrint
  // const handlePrint = () => {
  //   const printableArea = document.getElementById('printable-area');
  //   if (!printableArea) {
  //     console.error("Elemento #printable-area non trovato.");
  //     return;
  //   }

  //   const printContents = printableArea.innerHTML;
  //   const originalContents = document.body.innerHTML;
  //   const printStyles = `
  //     @page {
  //       size: landscape;
  //       margin: 1cm;
  //     }
  //     body {
  //       font-family: sans-serif;
  //     }
  //     table {
  //       font-size: 9pt;
  //       width: 100%;
  //       border-collapse: collapse;
  //     }
  //     th, td {
  //       white-space: nowrap;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       height: 20px;
  //       line-height: 20px;
  //       padding: 4px 8px;
  //       border: 1px solid #ccc;
  //       text-align: left;
  //     }
  //     th {
  //       font-weight: bold;
  //       background-color: #f2f2f2;
  //     }
  //     tr {
  //       page-break-inside: avoid !important;
  //     }
  //   `;

  //   // Create a new window or an iframe to print from
  //   const printWindow = window.open('', '_blank');
  //   printWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>Stampa Lista Evasione</title>
  //         <style>${printStyles}</style>
  //       </head>
  //       <body>
  //         ${printContents}
  //       </body>
  //     </html>
  //   `);
    
  //   printWindow.document.close();
  //   printWindow.focus();
    
  //   // Use a timeout to ensure content is loaded before printing
  //   setTimeout(() => {
  //     printWindow.print();
  //     printWindow.close();
  //   }, 250);
  // };

  const handleQuickFilterChange = (status) => {
    // Se il filtro rapido cliccato è già attivo, disattivalo
    if (quickFilterStatus === status) {
      setQuickFilterStatus(null);
    } else {
      setQuickFilterStatus(status);
      // Se si seleziona "Concluso", disattiva l'esclusione automatica
      if (status === 'Concluso' && excludeConcluded) {
        setExcludeConcluded(false);
        localStorage.setItem('ordini-exclude-concluded', JSON.stringify(false));
      }
    }
    setCurrentPage(1); // Reset pagina quando si cambia filtro
  };

  const handleToggleExcludeConcluded = () => {
    const newValue = !excludeConcluded;
    setExcludeConcluded(newValue);
    localStorage.setItem('ordini-exclude-concluded', JSON.stringify(newValue));
    // Se si attiva l'esclusione, rimuovi il filtro rapido su "Concluso"
    if (newValue && quickFilterStatus === 'Concluso') {
      setQuickFilterStatus(null);
    }
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    table.resetColumnFilters();
    setSorting([]);
    setQuickSearch('');
    setQuickFilterStatus(null);
    setExcludeConcluded(true);
    localStorage.setItem('ordini-exclude-concluded', JSON.stringify(true));
    setCurrentPage(1);
  };

  // Calcola il numero di filtri attivi
  const activeFiltersCount = useMemo(() => {
    let count = 0;
    if (columnFilters.length > 0) count += columnFilters.length;
    if (quickFilterStatus) count += 1;
    return count;
  }, [columnFilters, quickFilterStatus]);

  const hasManualFilters = activeFiltersCount > 0 || sorting.length > 0;

  // Seleziona una vista: ripristina la personalizzazione salvata per quella vista, se presente, altrimenti il preset di default
  const applyColumnPreset = (presetName) => {
    const preset = columnPresets[presetName];
    if (!preset) return;

    const savedVisibility = localStorage.getItem(getVisibilityKey(presetName));
    const newVisibility = savedVisibility
      ? JSON.parse(savedVisibility)
      : Object.keys(allColumnsMap).reduce((acc, key) => {
          acc[key] = preset.includes(key);
          return acc;
        }, {});

    const savedOrder = localStorage.getItem(getOrderKey(presetName));
    const newOrder = savedOrder
      ? ['select', ...JSON.parse(savedOrder).filter(c => c !== 'select')]
      : ['select', ...Object.keys(allColumnsMap)];

    setActiveView(presetName);
    setColumnVisibility(newVisibility);
    setColumnOrder(newOrder);
    localStorage.setItem(getVisibilityKey(presetName), JSON.stringify(newVisibility));
  };

  const toggleCondensedMode = () => {
    const newValue = !isCondensed;
    setIsCondensed(newValue);
    localStorage.setItem('table-condensed-ordini', JSON.stringify(newValue));
  };

  const handleAutoFitAllColumns = () => {
    const newSizing = {};
    
    // Get viewport width and reserve space for sticky columns and margins
    const viewportWidth = window.innerWidth;
    const reservedSpace = 200; // Checkbox + ID sticky columns + scrollbar + margins
    const availableWidth = viewportWidth - reservedSpace;
    
    // Get visible columns (excluding checkbox)
    const visibleColumns = table.getAllLeafColumns().filter(col => 
      col.id !== 'select' && col.getIsVisible()
    );
    
    // Define optimal widths for each column type
    const columnOptimalWidths = {
      'id': 80,
      'cliente_display': 200,
      'data_ordine': 110,
      'origine': 120,
      'numero_ordine_marketplace': 180,
      'acconto': 100,
      'totale_ordine': 110,
      'subtotale_imponibile': 130,
      'totale_iva': 100,
      'costo_prodotti': 120,
      'costo_marketplace': 140,
      'margine': 110,
      'margine_percentuale': 120,
      'stato': 140,
      'payment_method': 150,
      'corriere_denominazione': 150,
      'spese_trasporto': 130,
      'cliente_id': 90,
      'stato_spedizione': 140,
      'data_consegna': 120
    };
    
    // Calculate total optimal width
    let totalOptimalWidth = 0;
    visibleColumns.forEach(column => {
      const optimalWidth = columnOptimalWidths[column.id] || 120;
      totalOptimalWidth += optimalWidth;
    });
    
    // If total optimal width is less than available, use optimal widths
    // Otherwise, scale proportionally but with minimum constraints
    if (totalOptimalWidth <= availableWidth) {
      visibleColumns.forEach(column => {
        newSizing[column.id] = columnOptimalWidths[column.id] || 120;
      });
    } else {
      // Scale down but maintain minimum widths
      const scaleFactor = availableWidth / totalOptimalWidth;
      
      visibleColumns.forEach(column => {
        const optimalWidth = columnOptimalWidths[column.id] || 120;
        const scaledWidth = Math.floor(optimalWidth * scaleFactor);
        
        // Minimum widths by column type
        const minWidths = {
          'id': 70,
          'cliente_display': 150,
          'data_ordine': 100,
          'origine': 100,
          'stato': 120,
          'default': 90
        };
        
        const minWidth = minWidths[column.id] || minWidths.default;
        newSizing[column.id] = Math.max(minWidth, scaledWidth);
      });
    }
    
    setColumnSizing(newSizing);
  };

  const handleResetColumnWidths = () => {
    setColumnSizing({});
  };

  const handleArchivePdfs = async () => {
    if (selectedOrdineIds.length === 0) {
        alert("Nessun ordine selezionato per l'archiviazione PDF.");
        return;
    }
    if (window.confirm(`Sei sicuro di voler archiviare i PDF per ${selectedOrdineIds.length} ordini selezionati? I file verranno salvati sul server in 'C:\\databasedvd\\Dati\\Ordini Archiviati'.`)) {
        try {
            const response = await archiveOrdiniPdfs(selectedOrdineIds);
            const { success, failed } = response.data;
            let message = `${success.length} PDF archiviati con successo.`;
            if (failed.length > 0) {
                const failedIds = failed.map(f => f.id).join(', ');
                message += `\n\nFallimento per ${failed.length} ordini (ID: ${failedIds}). Controllare il log del server per i dettagli.`;
            }
            alert(message);
            table.toggleAllRowsSelected(false); // Deseleziona tutte le righe dopo l'operazione
        } catch (error) {
            console.error("Errore durante l'archiviazione dei PDF:", error);
            alert(`Si è verificato un errore durante l'archiviazione dei PDF: ${error.response?.data?.detail || error.message}`);
        }
    }
  };

  // ...deleteApiMap già dichiarato all'inizio del componente...

  const renderPaginationItems = () => {
    const totalPages = Math.ceil(totalOrdini / itemsPerPage);
    const pageNumbers = [];
    const maxPagesToShow = 5;
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
        startPage = 1;
        endPage = totalPages;
    } else {
        if (currentPage <= Math.ceil(maxPagesToShow / 2)) {
            startPage = 1;
            endPage = maxPagesToShow;
        } else if (currentPage + Math.floor(maxPagesToShow / 2) >= totalPages) {
            startPage = totalPages - maxPagesToShow + 1;
            endPage = totalPages;
        } else {
            startPage = currentPage - Math.floor(maxPagesToShow / 2);
            endPage = currentPage + Math.floor(maxPagesToShow / 2);
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
            <Pagination.Item key={i} active={i === currentPage} onClick={() => setCurrentPage(i)}>
                {i}
            </Pagination.Item>
        );
    }
    return pageNumbers;
  };

  // Helper functions for mobile cards
  const getStatoBadgeColor = (stato) => {
    switch (stato) {
      case 'DA_EVADERE': return 'warning';
      case 'EVASO': return 'success';
      case 'ANNULLATO': return 'danger';
      case 'RIMBORSATO': return 'dark';
      case 'PENDING_PAYMENT': return 'info';
      default: return 'secondary';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  // Funzione per renderizzare la card mobile di un ordine
  const renderOrdineCard = useCallback((ordine, isSelected, onToggleSelect) => {
    return (
      <Row>
        <Col xs={2} className="d-flex align-items-center justify-content-center">
          <Form.Check
            type="checkbox"
            checked={isSelected}
            onChange={onToggleSelect}
            style={{ transform: 'scale(1.3)' }}
          />
        </Col>
        <Col xs={10}>
          <div>
            {/* Header con ID e Status */}
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h6 className="mb-1">
                  <FontAwesomeIcon icon={faHashtag} className="text-primary me-1" />
                  Ordine #{ordine.id}
                </h6>
                <small className="text-muted">
                  <FontAwesomeIcon icon={faCalendar} className="me-1" />
                  {formatDate(ordine.data_ordine)}
                </small>
              </div>
              <Badge bg={getStatoBadgeColor(ordine.stato)}>
                {ordine.stato}
              </Badge>
            </div>

            {/* Cliente e Origine */}
            <div className="mb-2" style={{ fontSize: '0.85rem' }}>
              {(ordine.cliente_display || ordine.cliente?.nome || ordine.cliente?.cognome) && (
                <div className="mb-1">
                  <FontAwesomeIcon icon={faUser} className="text-primary me-2" />
                  <span className="fw-medium">
                    {ordine.cliente_display || 
                     (ordine.cliente?.nome && ordine.cliente?.cognome 
                      ? `${ordine.cliente.nome} ${ordine.cliente.cognome}`
                      : ordine.cliente?.nome || ordine.cliente?.cognome || 'Cliente non specificato')}
                  </span>
                </div>
              )}
              {ordine.origine && (
                <div className="mb-1">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="text-success me-2" />
                  <Badge bg="success" style={{ fontSize: '0.7rem' }}>{ordine.origine}</Badge>
                </div>
              )}
            </div>

            {/* Corriere */}
            {ordine.corriere_denominazione && (
              <div className="mb-2">
                <FontAwesomeIcon icon={faTruck} className="text-info me-2" />
                <small className="text-muted">{ordine.corriere_denominazione}</small>
              </div>
            )}

            {/* Totale ordine */}
            <div className="border-top pt-2 pb-1">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <FontAwesomeIcon icon={faEuroSign} className="text-success me-1" />
                  <strong className="text-success">{formatCurrency(ordine.totale_ordine)}</strong>
                </div>
                {ordine.payment_method && (
                  <Badge bg="info" style={{ fontSize: '0.7rem' }}>{ordine.payment_method}</Badge>
                )}
              </div>
            </div>

            {renderMarketplaceActionButton(ordine) && (
              <div className="mt-2" onClick={(e) => e.stopPropagation()}>
                {renderMarketplaceActionButton(ordine)}
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }, [processingMarketplaceIds, renderMarketplaceActionButton]);

  // Actions dropdown content for mobile
  const actionsDropdownContent = useMemo(() => (
    <>
      <Dropdown.Item onClick={handleExportSelected} disabled={selectedOrdineIds.length === 0 || exporting}>
        <FontAwesomeIcon icon={faFileExport} className="me-2" />
        {exporting ? 'Esportazione...' : 'Esporta selezionati (CSV)'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleExportAllExcel} disabled={exportingExcel}>
        <FontAwesomeIcon icon={faFileExport} className="me-2" />
        {exportingExcel ? 'Esportazione...' : 'Esporta tutto (Excel)'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleExportTracking} disabled={selectedOrdineIds.length === 0 || exportingTracking}>
        <FontAwesomeIcon icon={faFileExport} className="me-2" />
        {exportingTracking ? 'Esportazione tracking...' : 'Esporta tracking (Excel)'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleExportPacklink} disabled={selectedOrdineIds.length === 0 || exportingPacklink}>
        <FontAwesomeIcon icon={faFileExport} className="me-2" />
        {exportingPacklink ? 'Esportazione packlink...' : 'Export packlink CSV'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleExportPaccofacile} disabled={selectedOrdineIds.length === 0 || exportingPaccofacile}>
        <FontAwesomeIcon icon={faFileExport} className="me-2" />
        {exportingPaccofacile ? 'Esportazione PaccoFacile...' : 'Export PaccoFacile CSV'}
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item onClick={handleCreaSpedizioniPaccofacile} disabled={selectedOrdineIds.length === 0 || creandoSpedizioni}>
        <FontAwesomeIcon icon={faTruck} className="me-2" />
        {creandoSpedizioni ? 'Creazione spedizioni...' : 'Crea spedizioni PaccoFacile'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleSincronizzaPaccofacile} disabled={sincronizzandoPaccofacile}>
        <FontAwesomeIcon icon={faSync} className="me-2" />
        {sincronizzandoPaccofacile ? 'Sincronizzazione...' : 'Aggiorna tracking PaccoFacile'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleScaricaEtichette} disabled={selectedOrdineIds.length === 0 || scaricandoEtichette}>
        <FontAwesomeIcon icon={faPrint} className="me-2" />
        {scaricandoEtichette ? 'Download etichette...' : 'Scarica etichette PaccoFacile'}
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item onClick={handleCreaSpedizioniPacklink} disabled={selectedOrdineIds.length === 0 || creandoPacklink}>
        <FontAwesomeIcon icon={faTruck} className="me-2" />
        {creandoPacklink ? 'Creazione bozze...' : 'Crea spedizioni Packlink'}
      </Dropdown.Item>
      <Dropdown.Item onClick={handleSincronizzaPacklink} disabled={sincronizzandoPacklink}>
        <FontAwesomeIcon icon={faSync} className="me-2" />
        {sincronizzandoPacklink ? 'Sincronizzazione...' : 'Aggiorna tracking Packlink'}
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item onClick={handleShowPrintModal}>
        <FontAwesomeIcon icon={faPrint} className="me-2" />
        Stampa lista evasione
      </Dropdown.Item>
    </>
  ), [selectedOrdineIds.length, exporting, exportingExcel, exportingTracking, exportingPacklink, exportingPaccofacile, creandoSpedizioni, sincronizzandoPaccofacile, creandoPacklink, sincronizzandoPacklink, scaricandoEtichette, handleExportSelected, handleExportAllExcel, handleExportTracking, handleExportPacklink, handleExportPaccofacile, handleCreaSpedizioniPaccofacile, handleSincronizzaPaccofacile, handleCreaSpedizioniPacklink, handleSincronizzaPacklink, handleScaricaEtichette, handleShowPrintModal]);

  // Quick filters for mobile
  const quickFilters = useMemo(() => isFilteredView ? [] : [
    {
      label: excludeConcluded ? 'Solo attivi' : 'Tutti',
      active: !excludeConcluded && !quickFilterStatus,
      onClick: handleToggleExcludeConcluded,
      variant: !excludeConcluded && !quickFilterStatus ? 'primary' : 'outline-secondary'
    },
    {
      label: 'Da evadere',
      active: quickFilterStatus === 'Da Evadere',
      onClick: () => handleQuickFilterChange('Da Evadere'),
      variant: quickFilterStatus === 'Da Evadere' ? 'primary' : 'outline-primary'
    },
    {
      label: 'Parz. concluso',
      active: quickFilterStatus === 'Parz.Concluso',
      onClick: () => handleQuickFilterChange('Parz.Concluso'),
      variant: quickFilterStatus === 'Parz.Concluso' ? 'warning' : 'outline-warning'
    },
    {
      label: 'Concluso',
      active: quickFilterStatus === 'Concluso',
      onClick: () => handleQuickFilterChange('Concluso'),
      variant: quickFilterStatus === 'Concluso' ? 'success' : 'outline-success'
    }
  ], [isFilteredView, excludeConcluded, quickFilterStatus, handleToggleExcludeConcluded, handleQuickFilterChange]);

  // I contatori vanno sempre in navbar accanto al titolo (solo Nr. e Valore) invece delle
  // StatsCards nel corpo pagina, per lasciare piu' spazio verticale alla tabella.
  const headerInlineStats = useMemo(() => ([
    { label: 'Nr.', value: totalOrdini },
    { label: 'Val.', value: `€ ${totalAmount.toFixed(2)}` }
  ]), [totalOrdini, totalAmount]);

  return (
    <>
      {ordineDestinatario && (
        <DestinatarioOrdineModal
          ordine={ordineDestinatario}
          onClose={() => setOrdineDestinatario(null)}
          onResolved={() => { setOrdineDestinatario(null); fetchOrdiniData(); }}
        />
      )}
      {ordineRimborsi && (
        <RimborsiClienteModal
          ordine={ordineRimborsi}
          onClose={() => setOrdineRimborsi(null)}
          onDecided={() => { setOrdineRimborsi(null); fetchOrdiniData(); }}
        />
      )}
      {ordineMotivoRimborso && (
        <MotivoRimborsoModal
          ordine={ordineMotivoRimborso}
          messaggio={MESSAGGI_STATO_CHIUSURA['Rimborsato']}
          onClose={() => setOrdineMotivoRimborso(null)}
          onConfirm={(motivo) => {
            const ordine = ordineMotivoRimborso;
            setOrdineMotivoRimborso(null);
            handleChangeStato(ordine, 'Rimborsato', motivo);
          }}
        />
      )}
      {ordineVerificaCliente && (
        <VerificaClienteMarketplaceModal
          ordine={ordineVerificaCliente}
          onClose={() => setOrdineVerificaCliente(null)}
          onResolved={() => { setOrdineVerificaCliente(null); fetchOrdiniData(); }}
        />
      )}
      <StandardPageHeader
        title={
          quickParam === 'in_lavorazione' ? 'Ordini · In lavorazione' :
          quickParam === 'da_accettare' ? 'Ordini · Da accettare' :
          quickParam === 'concluso' ? 'Ordini · Conclusi' :
          quickParam === 'annullati' ? 'Ordini · Annullati e rimborsati' :
          quickParam === 'rimborsi' ? 'Ordini · Clienti con rimborsi precedenti' :
          quickParam === 'destinatario' ? 'Ordini · Destinatario da verificare' :
          quickParam === 'senza_rapporto' ? 'Ordini · Conclusi senza metodo di pagamento (non in contabilità)' :
          'Ordini'
        }
        inlineStats={headerInlineStats}
      />

      {(!isFilteredView || quickParam === 'in_lavorazione') && <CodiciOmaggioBox />}

    <Card style={{ marginBottom: '80px' }}>
      {/* Card.Header nascosto su mobile (≤991px) - MobileListLayout ha propria toolbar */}
      <Card.Header className="sticky-card-header d-none d-lg-block">{isMobile ? (
          // Mobile: non visibile (d-none d-lg-block), ma tenuto per sicurezza
          <div className="mobile-toolbar p-3 bg-light rounded-3 shadow-sm">
            <Row className="g-2 mb-3">
              <Col xs={7}>
                <Button 
                  as={Link} 
                  to="/nuovo/ordine" 
                  variant="success" 
                  className="w-100 fw-bold shadow-sm border-0"
                  style={{ 
                    background: 'linear-gradient(45deg, #28a745, #20c997)',
                    borderRadius: '12px',
                    padding: '10px'
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Nuovo Ordine
                </Button>
              </Col>
              <Col xs={5}>
                <Dropdown className="w-100">
                  <Dropdown.Toggle 
                    variant="primary" 
                    className="w-100 shadow-sm border-0"
                    style={{ 
                      background: 'linear-gradient(45deg, #007bff, #6610f2)',
                      borderRadius: '12px',
                      padding: '10px'
                    }}
                  >
                    <FontAwesomeIcon icon={faCog} className="me-1" />
                    Azioni
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100 shadow-lg border-0" style={{ borderRadius: '12px' }}>
                    <Dropdown.Header className="text-muted small">Esportazioni</Dropdown.Header>
                    <Dropdown.Item onClick={handleExportSelected} disabled={selectedOrdineIds.length === 0 || exporting} className="py-2">
                      <FontAwesomeIcon icon={faFileInvoice} className="me-2 text-primary" />
                      {exporting ? 'Esportazione...' : 'Esporta CSV'}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleExportAllExcel} disabled={exportingExcel} className="py-2">
                      <FontAwesomeIcon icon={faFileInvoice} className="me-2 text-success" />
                      {exportingExcel ? 'Esportazione...' : 'Esporta Excel'}
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleShowPrintModal} className="py-2">
                      <FontAwesomeIcon icon={faFileInvoice} className="me-2 text-info" />
                      Stampa Lista
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            
            <Row className="g-2 mb-2">
              <Col xs={12}>
                <Button
                  variant={!excludeConcluded && !quickFilterStatus ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={handleToggleExcludeConcluded}
                  className="w-100 shadow-sm border-0"
                  style={{ 
                    borderRadius: '10px',
                    fontWeight: '600',
                    padding: '8px'
                  }}
                >
                  <FontAwesomeIcon icon={excludeConcluded ? faEye : faEyeSlash} className="me-2" />
                  {excludeConcluded ? 'Solo ordini attivi' : 'Tutti gli ordini'}
                </Button>
              </Col>
            </Row>
            
            <Row className="g-2 mb-3">
              <Col xs={4}>
                <Button
                  variant={quickFilterStatus === 'Da Evadere' ? 'primary' : 'outline-primary'}
                  size="sm"
                  onClick={() => handleQuickFilterChange('Da Evadere')}
                  className="w-100 shadow-sm border-0"
                  style={{ 
                    borderRadius: '10px',
                    fontWeight: '600',
                    padding: '8px 4px'
                  }}
                >
                  <FontAwesomeIcon icon={faHourglassHalf} className="me-1" />
                  <div className="small">Da Evadere</div>
                </Button>
              </Col>
              <Col xs={4}>
                <Button
                  variant={quickFilterStatus === 'Parz.Concluso' ? 'warning' : 'outline-warning'}
                  size="sm"
                  onClick={() => handleQuickFilterChange('Parz.Concluso')}
                  className="w-100 shadow-sm border-0"
                  style={{ 
                    borderRadius: '10px',
                    fontWeight: '600',
                    padding: '8px 4px'
                  }}
                >
                  <FontAwesomeIcon icon={faClock} className="me-1" />
                  <div className="small">Parziale</div>
                </Button>
              </Col>
              <Col xs={4}>
                <Button
                  variant={quickFilterStatus === 'Concluso' ? 'success' : 'outline-success'}
                  size="sm"
                  onClick={() => handleQuickFilterChange('Concluso')}
                  className="w-100 shadow-sm border-0"
                  style={{ 
                    borderRadius: '10px',
                    fontWeight: '600',
                    padding: '8px 4px'
                  }}
                >
                  <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                  <div className="small">Concluso</div>
                </Button>
              </Col>
            </Row>
            
            <Row className="g-2 mb-2">
              <Col xs={12}>
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={handleSyncPendingMarketplaceOrders}
                  disabled={syncingPendingOrders}
                  className="w-100 shadow-sm border-0"
                  style={{ borderRadius: '10px', fontWeight: '600', padding: '8px' }}
                >
                  <FontAwesomeIcon icon={faSync} className={`me-2 ${syncingPendingOrders ? 'fa-spin' : ''}`} />
                  {syncingPendingOrders ? 'Verifica in corso...' : 'Verifica nuovi ordini'}
                </Button>
              </Col>
            </Row>
          </div>
        ) : (
          // Desktop: Layout originale
          <Row className="align-items-center">
          <Col md={5} className="d-flex justify-content-start align-items-center flex-wrap gap-2">
            <Button as={Link} to="/nuovo/ordine" size="sm" variant="success">Nuovo ordine</Button>
            <Button
              size="sm"
              variant="outline-primary"
              onClick={handleSyncPendingMarketplaceOrders}
              disabled={syncingPendingOrders}
              title="Interroga subito Mirakl per nuovi ordini IBS/Feltrinelli da accettare, senza aspettare il prossimo polling automatico"
            >
              <FontAwesomeIcon icon={faSync} className={`me-1 ${syncingPendingOrders ? 'fa-spin' : ''}`} />
              {syncingPendingOrders ? 'Verifica in corso...' : 'Verifica nuovi ordini'}
            </Button>
            <Dropdown>
              <Dropdown.Toggle variant="secondary" id="dropdown-basic" size="sm">
                Azioni
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleExportSelected} disabled={selectedOrdineIds.length === 0 || exporting}>
                  {exporting ? 'Esportazione...' : 'Esporta selezionati (CSV)'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExportAllExcel} disabled={exportingExcel}>
                  {exportingExcel ? 'Esportazione...' : 'Esporta tutto (Excel)'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExportTracking} disabled={selectedOrdineIds.length === 0 || exportingTracking}>
                  {exportingTracking ? 'Esportazione tracking...' : 'Esporta tracking (Excel)'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExportPacklink} disabled={selectedOrdineIds.length === 0 || exportingPacklink}>
                  {exportingPacklink ? 'Esportazione packlink...' : 'Export packlink CSV'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExportPaccofacile} disabled={selectedOrdineIds.length === 0 || exportingPaccofacile}>
                  {exportingPaccofacile ? 'Esportazione PaccoFacile...' : 'Export PaccoFacile CSV'}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleCreaSpedizioniPaccofacile} disabled={selectedOrdineIds.length === 0 || creandoSpedizioni}>
                  <FontAwesomeIcon icon={faTruck} className="me-2" />
                  {creandoSpedizioni ? 'Creazione spedizioni...' : 'Crea spedizioni PaccoFacile'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleSincronizzaPaccofacile} disabled={sincronizzandoPaccofacile}>
                  <FontAwesomeIcon icon={faSync} className="me-2" />
                  {sincronizzandoPaccofacile ? 'Sincronizzazione...' : 'Aggiorna tracking PaccoFacile'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleScaricaEtichette} disabled={selectedOrdineIds.length === 0 || scaricandoEtichette}>
                  <FontAwesomeIcon icon={faPrint} className="me-2" />
                  {scaricandoEtichette ? 'Download etichette...' : 'Scarica etichette PaccoFacile'}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleCreaSpedizioniPacklink} disabled={selectedOrdineIds.length === 0 || creandoPacklink}>
                  <FontAwesomeIcon icon={faTruck} className="me-2" />
                  {creandoPacklink ? 'Creazione bozze...' : 'Crea spedizioni Packlink'}
                </Dropdown.Item>
                <Dropdown.Item onClick={handleSincronizzaPacklink} disabled={sincronizzandoPacklink}>
                  <FontAwesomeIcon icon={faSync} className="me-2" />
                  {sincronizzandoPacklink ? 'Sincronizzazione...' : 'Aggiorna tracking Packlink'}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleShowPrintModal}>
                  Stampa lista evasione
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            
            {!isFilteredView && (
              <ButtonGroup size="sm">
                <Button
                  variant={!excludeConcluded && !quickFilterStatus ? 'primary' : 'outline-secondary'}
                  onClick={handleToggleExcludeConcluded}
                  title={excludeConcluded ? "Mostra anche ordini conclusi" : "Nascondi ordini conclusi"}
                >
                  {excludeConcluded ? 'Solo attivi' : 'Tutti'}
                </Button>
                <Button
                  variant={quickFilterStatus === 'Da Evadere' ? 'primary' : 'outline-secondary'}
                  onClick={() => handleQuickFilterChange('Da Evadere')}
                >
                  Da evadere
                </Button>
                <Button
                  variant={quickFilterStatus === 'Parz.Concluso' ? 'primary' : 'outline-secondary'}
                  onClick={() => handleQuickFilterChange('Parz.Concluso')}
                >
                  Parz. concluso
                </Button>
                <Button
                  variant={quickFilterStatus === 'Concluso' ? 'primary' : 'outline-secondary'}
                  onClick={() => handleQuickFilterChange('Concluso')}
                >
                  Concluso
                </Button>
              </ButtonGroup>
            )}
          </Col>
          

          <Col md={4} className="d-flex justify-content-end align-items-center flex-wrap gap-2">

            <Dropdown autoClose="outside">
              <Dropdown.Toggle variant="outline-secondary" id="dropdown-viste" size="sm">
                Viste
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => applyColumnPreset('essenziale')}>
                  📋 Vista essenziale
                </Dropdown.Item>
                <Dropdown.Item onClick={() => applyColumnPreset('finanziaria')}>
                  💰 Vista finanziaria
                </Dropdown.Item>
                <Dropdown.Item onClick={() => applyColumnPreset('logistica')}>
                  🚚 Vista logistica
                </Dropdown.Item>
                <Dropdown.Item onClick={() => applyColumnPreset('completa')}>
                  📊 Vista completa
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleAutoFitAllColumns}>
                  ⚡ Auto-fit tutte
                </Dropdown.Item>
                <Dropdown.Item onClick={handleResetColumnWidths}>
                  🔄 Reset larghezze
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown autoClose="outside">
              <Dropdown.Toggle variant="outline-secondary" id="dropdown-columns" size="sm">
                Colonne
              </Dropdown.Toggle>
              <Dropdown.Menu className="long-dropdown-menu p-0" style={{ minWidth: '500px' }}>
                <div className="d-flex">
                  <div className="p-2" style={{ flex: 1, borderRight: '1px solid #dee2e6' }}>
                    <ColumnOrderController
                      table={table}
                      allColumnsMap={allColumnsMap}
                    />
                  </div>
                  <div className="p-2" style={{ flex: 1 }}>
                    <h6 className="fw-bold">Mostra colonne</h6>
                    <div className="d-flex flex-column" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                      {table.getAllColumns().filter(column => column.id !== 'select' && column.id !== 'actions').map(column => (
                        <Form.Check
                          key={column.id}
                          type="checkbox"
                          label={allColumnsMap[column.id]}
                          checked={column.getIsVisible()}
                          onChange={column.getToggleVisibilityHandler()}
                          className="dropdown-item"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            
            <Button
              variant={isCondensed ? 'primary' : 'outline-secondary'}
              size="sm"
              onClick={toggleCondensedMode}
              title="Modalità condensata"
            >
              {isCondensed ? '📋 Compatto' : '📋 Normale'}
            </Button>
            
            <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleResetFilters}
                disabled={!hasManualFilters}
            >
                Azzera filtri
                {activeFiltersCount > 0 && (
                  <Badge bg="danger" className="ms-2">{activeFiltersCount}</Badge>
                )}
            </Button>
          </Col> {/* TAG DI CHIUSURA COL */}

          </Row>
        )}
      </Card.Header>
      <Card.Body>
        {loading && <div className="text-center"><Spinner animation="border" /></div>}
        {error && <Alert variant="danger">{error}</Alert>}
        {!loading && !error && (
          <div style={{ paddingBottom: isMobile && selectedOrdineIds.length > 0 ? '80px' : '0' }}>
            {isMobile ? (
              <MobileListLayout
                entityName="ordine"
                entityNamePlural="ordini"
                createPath="/nuovo/ordine"
                createButtonText="Nuovo Ordine"
                createButtonIcon={faPlus}
                actionsDropdownContent={actionsDropdownContent}
                quickFilters={quickFilters}
                searchPlaceholder="Cerca ordini..."
                searchValue={quickSearch}
                activeFiltersCount={activeFiltersCount}
                onSearchChange={(e) => setQuickSearch(e.target.value)}
                items={table.getRowModel().rows.map(row => row.original)}
                selectedIds={selectedOrdineIds}
                renderCard={renderOrdineCard}
                onCardClick={(ordine) => navigate(`/ordini/${ordine.id}`)}
                onToggleSelect={(id) => {
                  const row = table.getRowModel().rows.find(r => r.original.id === id);
                  if (row) row.toggleSelected();
                }}
                onDeleteMultiple={async (ids) => {
                  await deleteMultipleApiMap['ordini'](ids);
                  fetchOrdiniData();
                  setSelectedOrdineIds([]);
                  if (table) table.toggleAllRowsSelected(false);
                }}
              />
            ) : (
              <div style={{ maxHeight: 'calc(100vh - 350px)', overflow: 'auto' }}>
                <Table 
                  striped 
                  bordered 
                  hover 
                  style={{ width: table.getTotalSize() }} 
                  className={`aligned-table enhanced-table ${isCondensed ? 'table-condensed' : ''}`}
                >
                <thead>
                  {table.getHeaderGroups().map(headerGroup => (
                  <React.Fragment key={headerGroup.id}>
                    <tr>
                      {headerGroup.headers.map(header => (
                        <SortableHeader key={header.id} header={header} table={table} handleAutoResize={handleAutoResize} stickyColumns={['select']} />
                      ))}
                    </tr>

                  </React.Fragment>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map(row => (
                    <tr key={row.id} onClick={() => handleRowClick(row)} className={row.getIsSelected() ? 'table-primary' : ''} style={{ cursor: 'pointer' }}>
                      {row.getVisibleCells().map(cell => {
                        const isSelectColumn = cell.column.id === 'select';
                        const isIdColumn = cell.column.id === 'id';
                        let className = '';
                        if (isSelectColumn) {
                          className = 'sticky-col-checkbox';
                        }
                        if (isIdColumn) {
                          className += ' text-primary fw-bold';
                        }

                        return (
                          <td
                            key={cell.id}
                            className={className}
                            style={{
                              verticalAlign: 'middle',
                              width: cell.column.getSize(),
                              minWidth: cell.column.getSize(),
                              maxWidth: cell.column.getSize(),
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              cursor: isIdColumn ? 'pointer' : undefined
                            }}
                            onClick={isIdColumn ? (e) => handleIdCellClick(e, row.original.id) : undefined}
                            title={isIdColumn ? "Click: visualizza ordine — Doppio click: modifica ordine" : (typeof cell.getValue() === 'string' ? cell.getValue() : '')}
                          >
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </Table>
              </div>
            )}
          </div>
        )}
        
        {/* Action Toolbar - Desktop version */}
        {!isMobile && (
          <ActionToolbar
            selectedItemIds={selectedOrdineIds}
            entityType="ordini"
            onDeleteSuccess={() => {
              fetchOrdiniData();
              setSelectedOrdineIds([]);
              if (table) table.toggleAllRowsSelected(false);
            }}
            deleteApiMap={deleteApiMap}
            deleteMultipleApiMap={deleteMultipleApiMap}
            onBulkEdit={() => setShowBulkEditModal(true)}
            onArchivePdfs={handleArchivePdfs}
            onConcludiConTracking={() => handleOpenTrackingModal(ordini.filter(o => selectedOrdineIds.includes(o.id)))}
          />
        )}
        
        {/* Mobile Sticky Action Bar - Appare solo con selezioni */}
        {isMobile && selectedOrdineIds.length > 0 && (
          <div 
            className="mobile-action-bar"
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: '#fff',
              borderTop: '2px solid #007bff',
              padding: '12px 16px',
              boxShadow: '0 -4px 12px rgba(0,0,0,0.15)',
              zIndex: 1000,
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <div className="flex-grow-1">
              <strong className="text-primary">{selectedOrdineIds.length}</strong>
              <span className="text-muted ms-1">
                {selectedOrdineIds.length === 1 ? 'ordine selezionato' : 'ordini selezionati'}
              </span>
            </div>
            <Button 
              variant="primary" 
              size="sm"
              onClick={() => setShowBulkEditModal(true)}
              className="shadow-sm"
            >
              <FontAwesomeIcon icon={faCog} className="me-1" />
              Modifica
            </Button>
            <Button 
              variant="info" 
              size="sm"
              onClick={handleArchivePdfs}
              className="shadow-sm"
            >
              <FontAwesomeIcon icon={faFileInvoice} />
            </Button>
            <Button 
              variant="danger" 
              size="sm"
              onClick={() => {
                if (window.confirm(`Vuoi eliminare ${selectedOrdineIds.length} ordine/i selezionato/i?`)) {
                  deleteMultipleApiMap['ordini'](selectedOrdineIds)
                    .catch((err) => alert(err.response?.data?.detail || "Errore durante l'eliminazione"))
                    .finally(() => {
                      fetchOrdiniData();
                      setSelectedOrdineIds([]);
                      if (table) table.toggleAllRowsSelected(false);
                    });
                }
              }}
              className="shadow-sm"
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
        )}
      </Card.Body>
      {!isMobile && (
        <Card.Footer className="d-flex justify-content-between align-items-center">
          <Form.Group as={Row} className="align-items-center mb-0">
            <Col xs="auto">
              <Form.Label className="mb-0">Record per pagina</Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Select
                size="sm"
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Pagination size="sm" className="mb-0">
            <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => setCurrentPage(prev => prev - 1)} disabled={currentPage === 1} />
            {renderPaginationItems()}
            <Pagination.Next onClick={() => setCurrentPage(prev => prev + 1)} disabled={currentPage === Math.ceil(totalOrdini / itemsPerPage)} />
            <Pagination.Last onClick={() => setCurrentPage(Math.ceil(totalOrdini / itemsPerPage))} disabled={currentPage === Math.ceil(totalOrdini / itemsPerPage)} />
          </Pagination>
        </Card.Footer>
      )}
      {isMobile && totalOrdini > itemsPerPage && (
        // Su telefono senza questa barra si vedevano solo i primi ordini del filtro
        <div className="d-flex justify-content-between align-items-center px-2 py-2">
          <Button size="sm" variant="outline-secondary" disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>‹ Prec.</Button>
          <small className="text-muted">Pagina {currentPage} di {Math.ceil(totalOrdini / itemsPerPage)}</small>
          <Button size="sm" variant="outline-secondary" disabled={currentPage >= Math.ceil(totalOrdini / itemsPerPage)} onClick={() => setCurrentPage(prev => prev + 1)}>Succ. ›</Button>
        </div>
      )}

      {/* Stili CSS per react-select - TODO: spostare in CSS globale */}
      {/* styled-jsx non supportato in React normale, questi stili vanno in index.css o App.css */}
      {/* Gli stili react-select funzionano anche senza questo blocco grazie alle classi Bootstrap */}

      {/*
      <Modal show={showPrintModal} onHide={() => setShowPrintModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Lista Evasione Ordini</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="printable-area">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>BARCODE</th>
                  <th>TITOLO/DESCRIZIONE</th>
                  <th>QT.</th>
                  <th>UBICAZIONE</th>
                  <th>CLIENTE</th>
                </tr>
              </thead>
              <tbody>
                {printDataItems.length > 0 ? (
                  printDataItems.map((item, index) => (
                    <tr key={index}>
                      <td>{item.barcode}</td>
                      <td>{item.titolo}</td>
                      <td>{item.quantita}</td>
                      <td>{item.ubicazione}</td>
                      <td>{item.cliente}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">Nessun ordine 'Da Evadere' trovato.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPrintModal(false)}>
            Chiudi
          </Button>
          <Button variant="primary" onClick={handlePrint}>
            Stampa
          </Button>
        </Modal.Footer>
      </Modal>
      */}
    </Card>
    <BulkEditOrdineModal
      show={showBulkEditModal}
      onHide={() => setShowBulkEditModal(false)}
      selectedIds={selectedOrdineIds}
      onSuccess={() => {
        fetchOrdiniData();
        table.toggleAllRowsSelected(false);
        setShowBulkEditModal(false);
      }}
    />
    <TrackingBatchModal
      show={trackingModalOrdini.length > 0}
      onHide={() => setTrackingModalOrdini([])}
      ordini={trackingModalOrdini}
      onSuccess={() => {
        fetchOrdiniData();
        table.toggleAllRowsSelected(false);
      }}
    />
    </>
  );
}

export default OrdiniList;
